const WALLET_PROVIDER_ID_FIELD_NAME = "providerId";
const WALLET_ID_FIELD_NAME = "walletId";

const WalletPreference = Object.freeze({
  Additional: "Additional",
  Primary: "Primary",
});

export {WALLET_ID_FIELD_NAME, WALLET_PROVIDER_ID_FIELD_NAME, WalletPreference};
